import * as React from "react";

const GSChildInformation = ({ name, age, sex, missingDate }) => {
  return (
    <div>
      <h2>Child Information:</h2>
      <div className="geosearch-result__child-info">
        <div className="geosearch-result__child-name">
          <h5>Name:</h5>
          <p>{name}</p>
        </div>
        <div className="geosearch-result__child-age">
          <h5>Age:</h5>
          <p>{age}</p>
        </div>
        <div className="geosearch-result__child-sex">
          <h5>Sex:</h5>
          <p>{sex}</p>
        </div>
        <div className="geosearch-result__missing-date">
          <h5>Missing Date:</h5>
          <p>{missingDate}</p>
        </div>
      </div>
    </div>
  );
};

export default GSChildInformation;
